module.exports = __webpack_public_path__ + "static/5-9844d6df54e90e54d2e47712a7c30b55.jpg";